export const ROW_CLASSES_SHARED =
  "tw-gap-2 tw-px-1 tw-h-8 tw-items-center tw-border-0 tw-border-b tw-border-theme-300 tw-border-solid";
export const ROW_CLASSES_ITEM = "tw-grid tw-grid-cols-[64px_minmax(132px,_1fr)_112px_112px]";
export const ROW_CLASSES_TOTAL = "tw-grid tw-grid-cols-[1fr_112px]";
